import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { screenshareDeleted, screensharesDeleted } from 'features/layout/features/order/orderSlice';
import { RootState } from 'store/store';
import {
  ScreenshareState,
  SelectedScreenshare,
  ScreenshareGridDimensions,
} from 'features/screenshare/types';

export const initialState: ScreenshareState = {
  selectedScreenshare: null,
  showAllScreens: false,
  gridDimensions: {
    cols: 1,
    rows: 1,
    tileHeight: 0,
    tileWidth: 0,
    maxTiles: 1,
  },
};

export const screenshareSlice = createSlice({
  name: 'screenshare',
  initialState,
  reducers: {
    gridDimensionsChanged(state, action: PayloadAction<ScreenshareGridDimensions>) {
      state.gridDimensions = action.payload;
    },
    selectedScreenshareChanged(state, action: PayloadAction<SelectedScreenshare>) {
      state.selectedScreenshare = action.payload;
    },
    selectedScreenshareClosed(state) {
      state.selectedScreenshare = null;
    },
    showAllScreensChanged(state, action: PayloadAction<boolean>) {
      state.showAllScreens = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(screenshareDeleted, (state, action) => {
      const { feedId } = action.payload;

      if (state.selectedScreenshare?.feedId === feedId) {
        state.selectedScreenshare = null;
      }
    });

    builder.addCase(screensharesDeleted, (state, action) => {
      const selectedFeedId = state.selectedScreenshare?.feedId;

      if (selectedFeedId && action.payload.ids.includes(selectedFeedId)) {
        state.selectedScreenshare = null;
      }
    });
  },
});

export const {
  gridDimensionsChanged,
  selectedScreenshareChanged,
  selectedScreenshareClosed,
  showAllScreensChanged,
} = screenshareSlice.actions;

export const selectSelectedScreenshare = (state: RootState) =>
  state.screenshare.selectedScreenshare;

export const selectShowAllScreens = (state: RootState) => state.screenshare.showAllScreens;

export const selectGridDimensions = (state: RootState) => state.screenshare.gridDimensions;

export default screenshareSlice.reducer;
